import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import Form from 'devextreme-react/form';
import 'devextreme-react/autocomplete';
import 'devextreme-react/date-range-box';
import { applicationService } from '@/projects/admin/services/application-service';
import { IAccount, IApplciationModule } from '@/core/interfaces/admin/usestate-interfaces';
import { useNavigate, useParams } from 'react-router-dom';
import { ELEMENT_ID } from '@/core/constants/common/element-constants';
import FormWrapper from '@/core/wrappers/form-wrapper';
import { BUTTON_CONSTANTS } from '@/core/constants/common/button-contants';
import CustomStore from 'devextreme/data/custom_store';
import { t } from 'i18next';
import { ROUTER_CONSTANTS } from '@/core/constants/common/router-constants';


function ApplicationModuleDefinition() {

    const params = useParams();
    const navigate = useNavigate();
    const formRef: any = useRef<Form>();
    const [applicationModule, setApplicationModule] = useState<IApplciationModule>({ id: '', name: '', applicationId: null, order: 0 });

    const applicationStore = useMemo(() => {
        if (!applicationModule) return null;

        return new CustomStore({
            key: 'id',
            load: applicationService.lookupApplication,
            byKey: async (key, loadOptions: any) => {
                let returnObject = null;
                if (key) {
                    loadOptions.filter = ["id", "=", key];
                    const objectsByID = (await applicationService.lookupApplication(loadOptions))
                    returnObject = objectsByID.data.length > 0 ? objectsByID.data[0] : null;
                }
                return returnObject
            },
            useDefaultSearch: true
        });
    }, [applicationModule]);

    useEffect(() => {
        if (params.id) {

            applicationService.getApplicationModule(params.id).then((result) => {
                const data = result.data;
                setApplicationModule({ id: data.id, name: data.name, applicationId: data.applicationId, order: data.order })
            })
        }
    }, []);

    const handleSubmit = useCallback(async (): Promise<void> => {
        return new Promise(async (resolve, reject) => {
            try {
                const formData = formRef.current.props.formData;
                if (params.id) {
                    await applicationService.updateApplicationModule(null, formData);
                } else {
                    await applicationService.createApplicationModule(formData);
                }
                resolve();
                navigate('/admin/' + ROUTER_CONSTANTS.ADMIN.ApplicationModules, {})
            } catch (error) {
                reject(error)
            }

        })
    }, []);


    const applicationEditorOptions = {
        dataSource: applicationStore,
        displayExpr: 'name',
        valueExpr: 'id',
        placeholder: undefined,
        showClearButton: true,
    };

    return (
        <>
            <FormWrapper
                onSubmit={handleSubmit}
                formRef={formRef}
                formData={applicationModule}
                backButtonNavigationPath={'/admin/' + ROUTER_CONSTANTS.ADMIN.ApplicationModules}
                isAddBackBtn={true}
                buttonGroups=
                {[
                    { buttonOptions: BUTTON_CONSTANTS.SaveBtn }
                ]}
                simpleItemGroups={[
                    {
                        caption: applicationModule.id == '' ? t('new_module') : t('edit_module'),
                        useColCountByScreen: true,
                        items: [
                            {
                                dataField: 'name',
                                editorType: 'dxTextBox',
                                label: 'name',
                                isRequired: true,

                            },
                            {
                                dataField: 'applicationId',
                                editorType: 'dxSelectBox',
                                editorOptions: applicationEditorOptions,
                                label: 'application',
                            }
                        ],

                    }
                ]}
            />
        </>
    );
}
export default ApplicationModuleDefinition;